export default __webpack_public_path__ + "static/media/thrive_agric.e92719e7.jpeg";